"use client";
import { useTranslations } from "next-intl";
import { useI18n } from "../providers/ClientI18nProvider";
import { locales, localeLabels, shortLocaleCodes, type Locale } from "@i18n/config";

export const LanguageSwitcher = () => {
  const t = useTranslations("settings");
  // Use locale from our seamless context if available, fallback to next-intl's hook
  // (though inside ClientI18nProvider these should be in sync)
  const { changeLocale, locale: currentLocale, isLoading } = useI18n();

  const handleLanguageChange = async (newLocale: Locale) => {
    if (newLocale === currentLocale || isLoading) return;

    // Use context to switch language seamlessly
    await changeLocale(newLocale);
  };

  return (
    <div className="language-switcher">
      <div className="grid grid-cols-4 gap-2">
        {locales.map((locale) => (
          <button
            key={locale}
            onClick={() => handleLanguageChange(locale)}
            title={localeLabels[locale]}
            className={`
              relative px-3 py-2.5 rounded-lg font-semibold text-sm
              transition-all duration-200
              ${
                currentLocale === locale
                  ? "bg-primary text-white shadow-md ring-2 ring-primary/20"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:shadow-sm"
              }
            `}
          >
            <span className="block">{shortLocaleCodes[locale]}</span>
            <span className="block text-xs font-normal mt-0.5 opacity-80">
              {locale === "en" && "US"}
              {locale === "ar" && "عربي"}
              {locale === "fr" && "FR"}
              {locale === "de" && "DE"}
            </span>
          </button>
        ))}
      </div>
      <p className="text-xs text-gray-500 mt-3 px-1">{t("languageChangeNote")}</p>
    </div>
  );
};
